import { useState, useEffect } from "react";
import axios from "axios";
import Article from "./Article";
import ArticleCardLoading from "./CardLoading";
import "./Article.css";

function ArticleContainer({ limit }) {
  const [data,    setData]    = useState([]);
  const [loading, setLoading] = useState(true);
  const pageApiPath = process.env.REACT_APP_PAGES_API_PATH;
  const apiKey      = process.env.REACT_APP_API_KEY;

  useEffect(() => {
    axios
      .get(pageApiPath, {
        headers: { Authorization: `Api-Key ${apiKey}` },
        params: { type: "Article.ArticlePage", fields: "thumbnail,cover,intro,body", order: "-first_published_at" },
      })
      .then((res) => setData(res.data.items))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [pageApiPath, apiKey]);

  const visible = limit ? data.slice(0, limit) : data;
  const skeletonCount = limit ?? 4;

  if (loading) {
    return (
      <div className="article-grid">
        {Array.from({ length: skeletonCount }, (_, i) => <ArticleCardLoading key={i} />)}
      </div>
    );
  }

  if (!visible.length) {
    return (
      <div className="no-data">
        <p className="body-large" style={{ fontWeight: 600 }}>No articles found</p>
      </div>
    );
  }

  return (
    <div className="article-grid">
      {visible.map((d) => (
        <Article
          key={d.id}
          link={d.id}
          image={d.thumbnail?.url || ""}
          heading={d.title}
          description={d.intro}
        />
      ))}
    </div>
  );
}

export default ArticleContainer;
